import {
  PlacementWithLogical,
  PopoverContent,
  Popover,
  PopoverTrigger
} from '@chakra-ui/react';
import React from 'react';

interface DropDownProps {
  onClose(): void;
  onOpen(): void;
  isOpen: boolean;
  placement: PlacementWithLogical;
  popoverContent: React.ReactNode;
  children: React.ReactNode;
  variant?: string;
  noMaxHeight?: boolean;
}

function DropDown({
  onClose,
  isOpen,
  onOpen,
  placement,
  children,
  variant,
  popoverContent,
  noMaxHeight = false,
}: DropDownProps) {
  return (
    <Popover
      placement={placement}
      onClose={onClose}
      isOpen={isOpen}
      onOpen={onOpen}
      flip={false}
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <PopoverContent
        className={`popover-content ${variant}`}
        maxHeight={noMaxHeight ? 'unset !important' : '400px'}
      >
        { popoverContent }
      </PopoverContent>
    </Popover>
  );
}

export default DropDown;
